export default {
      id: "mail-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#mail",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mail.svg
// module id = 133
// module chunks = 241 242 243